import { DiscountCodeCombinedProps } from './types';

const usePresenter = (props: DiscountCodeCombinedProps): DiscountCodeCombinedProps => {
  return props;
};

export default usePresenter;
